import React from 'react';
import { Wrapper, Footer, LineChart, MiniLineChart, CardDevices, CardActivity, CardList, DataTable, ProfileAccordion } from '../../components';

class Dashboard extends React.Component{
    
    constructor(props) {
        super(props);
    
        this.state = {
            dataLine1: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [7, 7, 9, 10, 11],
                    fill: false
                  }
                ]
            },
            dataLine2: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [5, 7, 8, 9, 11],
                    fill: false
                  }
                ]
            },
            dataLine3: {
                labels: ['Jan','Feb','Mar','Apr','May'],
                datasets: [
                  {
                    backgroundColor:'#ffffff',
                    borderColor:'#ffffff',
                    data: [7, 9, 8, 6, 9],
                    fill: false
                  }
                ]
            }
        };
    }
    
    render(){
        return (
            <Wrapper>
                <main className="flex-fill">
                    <section className="row mt-1">
                        <div className="col-lg-6 pb-3 wow fadeInUp">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-xl-3 p-2 d-flex flex-column">
                                    <h4 className="font-weight-light mb-3">Page Views</h4>
                                    <div className="my-xl-auto p-1">
                                        <LineChart />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 pb-3 wow fadeInUp" data-wow-delay=".5s">
                            <CardDevices />
                        </div>
                        <div className="col-xl-3 col-lg-12 pb-3 wow fadeInUp" data-wow-delay="1s">
                            <CardActivity />
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-xl-9 col-md-8 py-3">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item"><a href="#tab1" className="nav-link text-uppercase active" data-toggle="tab" data-target="#tab1" role="tab">Log</a></li>
                                        <li className="nav-item"><a href="#tab2" className="nav-link text-uppercase" data-toggle="tab" data-target="#tab2" role="tab">Users</a></li>
                                    </ul>
                                    <div className="tab-content py-4">
                                        <div className="tab-pane active" id="tab1" role="tabpanel">
                                            <CardList />
                                        </div>
                                        <div className="tab-pane" id="tab2" role="tabpanel">
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-12 d-flex flex-column">
                                                    <div className="card text-white bg-primary flex-grow-1 shadow-sm">
                                                        <div className="card-body">
                                                            <h3 className="card-title">Bots</h3>
                                                            <p className="card-text">Click on a robot friend to learn more about them.</p>
                                                            <button className="btn btn-outline-light border-white text-white">Button</button>
                                                        </div>
                                                    </div>
                                                    <div className="card text-white bg-primary my-4 flex-grow-1 shadow-sm">
                                                        <div className="card-body">
                                                            <div className="float-right dropdown show"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle text-white"><i className="align-middle lnr lnr-cog"></i></button>
                                                                <div className="dropdown-menu dropdown-menu-right">
                                                                    <button className="dropdown-item">Action</button>
                                                                    <button className="dropdown-item">Another action</button>
                                                                </div>
                                                            </div>
                                                            <h4 className="card-title">Working</h4>
                                                            <p className="card-text">
                                                                This template features <em>working</em> components to demonstrate realistic use and implementation.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="card text-white bg-primary flex-grow-1 shadow-sm mb-4 mb-xl-0">
                                                        <div className="card-body">
                                                            <h3 className="card-title">Flexible</h3>
                                                            <p className="card-text">The beauty of responsive design is that it works on all devices.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <ProfileAccordion className="border rounded shadow-sm" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-4 py-3 d-sm-block d-none">
                            <div className="card bg-primary border-0 h-100 shadow-sm">
                                <div className="card-body d-flex flex-column justify-content-between">
                                    <h4 className="font-weight-light">
                                        <div className="float-right dropdown show"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle"><i className="lnr lnr-cog"></i></button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                                <button className="dropdown-item">Action</button>
                                                <button className="dropdown-item">Another action</button>
                                            </div>
                                        </div>
                                        Leads
                                    </h4>
                                    <div className="text-center py-2">
                                        <MiniLineChart ref="miniLineChart1" data={this.state.dataLine1} className="mb-2 p-1 mx-auto" />
                                        May 2018
                                    </div>
                                    <div className="text-center py-2">
                                        <MiniLineChart ref="miniLineChart2" data={this.state.dataLine2} className="mb-2 p-1 mx-auto" />
                                        Jun 2018
                                    </div>
                                    <div className="text-center py-2">
                                        <MiniLineChart ref="miniLineChart3" data={this.state.dataLine3} className="mb-2 p-1 mx-auto" />
                                        July 2018
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col py-3">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <DataTable /> 
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="row mt-1 wow fadeInUp" data-wow-delay=".3s">
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Health</h5>
                                        <h3 className="text-nowrap">99.3%</h3>
                                    </div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="." lass="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-heart"></span></a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Cycles</h5>
                                        <h3>53</h3></div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="." className="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-history"></span></a></h1></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Storage</h5>
                                        <h3 className="text-nowrap">69%</h3>
                                    </div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="." className="nav-link pb-0" title="View details"><span className="d-inline-block lnr lnr-database"></span></a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl col-sm-6 pb-3">
                            <div className="card d-block p-1 h-100 shadow-sm">
                                <div className="row h-100 no-gutters">
                                    <div className="col-6 p-3 py-4">
                                        <h5 className="text-truncate">Signal</h5>
                                        <h3>4.1</h3></div>
                                    <div className="col bg-light text-success d-flex">
                                        <h1 className="mb-0 mx-auto align-self-center"><a href="." className="nav-link pb-0" title="View details"><i className="lnr lnr-heart-pulse"></i></a></h1></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </Wrapper>
        );
    }
}

export default Dashboard;
